import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'


import * as types from '@/common/types/mutation.js'

import Cookies from 'js-cookie'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../components/FinancePage.vue'),
        meta: {
            title: '首页',
            requiresAuth: true
        },
    },
    {
        path: '/finance',
        name: 'finance',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/finance/MyFinance.vue'),
        meta: {
            title: '账本',
            requiresAuth: true
        },
    },
    {
        path: '/pageLogin',
        name: 'pageLogin',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Login.vue'),
        meta: {
            title: '登录',
            requiresAuth: false,
            isShowTabbar:false
        },
    },
    {
        path: '/finList',
        name: 'finList',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/report/FinList.vue'),
        meta: {
            title: '账单列表',
            requiresAuth: true
        },
    },
    {
        path: '/popupFinList',
        name: 'popupFinList',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/report/PopupFinList.vue'),
        meta: {
            title: '账单列表',
            requiresAuth: true
        },
    },
    {
        path: '/finReport',
        name: 'finReport',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/report/FinReport.vue'),
        meta: {
            title: '账单列表',
            requiresAuth: true
        },
    },
    {
        path: '/finStatistics',
        name: 'finStatistics',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/FinStatistics.vue'),
        meta: {
            title: '统计',
            requiresAuth: true
        },
    },
    {
        path: '/finDayCount',
        name: 'finDayCount',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route

        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/statistics/FinDayCount.vue'),
        meta: {
            title: '日消费统计',
            requiresAuth: true
        },
    },
    {
        path: '/userPage',
        name: 'userPage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route

        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/UserPage.vue'),
        meta: {
            title: '我的',
            requiresAuth: true
        },
    },
    {
        path: '/openStatistics',
        name: 'openStatistics',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/statistics/OpenStatistics.vue'),
        meta: {
            title: '聊天统计',
            requiresAuth: false
        },
    },
    {
        path: '/pocketMoney',
        name: 'pocketMoney',
        component: () => import(/* webpackChunkName: "about" */ '../components/mine/PocketMoney.vue'),
        meta: {
            title: '零花钱',
            requiresAuth: true
        },
    },
    {
        path: '/tagPage',
        name: 'tagPage',
        component: () => import(/* webpackChunkName: "about" */ '../components/mine/TagPage.vue'),
        meta: {
            title: '标签维护',
            requiresAuth: true
        },
    },
    {
        path: '/sortPage',
        name: 'sortPage',
        component: () => import(/* webpackChunkName: "about" */ '../components/mine/SortPage.vue'),
        meta: {
            title: '标签维护',
            requiresAuth: true
        },
    },
    {
        path: '/workOvertime',
        name: 'workOvertime',
        component: () => import(/* webpackChunkName: "about" */ '../components/mine/WorkOvertime.vue'),
        meta: {
            title: '加班记录',
            requiresAuth: true
        },
    },
    {
        path: '/financePage',
        name: 'financePage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/FinancePage.vue'),
        meta: {
            title: '账本',
            requiresAuth: true
        },
    },
    {
        path: '/tranceFinance',
        name: 'tranceFinance',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/finance/TranceFinance.vue'),
        meta: {
            title: '在途修改',
            requiresAuth: true
        },
    },
    {
        path: '/tranceFinanceDetail',
        name: 'tranceFinanceDetail',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/finance/TranceFinanceDetail.vue'),
        meta: {
            title: '在途详情修改',
            requiresAuth: true
        },
    },
    {
        path: '/reportPage',
        name: 'reportPage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/ReportPage.vue'),
        meta: {
            title: '在途修改',
            requiresAuth: true
        },
    },
    {
        path: '/pushMsg',
        name: 'pushMsg',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/mine/PushMsg.vue'),
        meta: {
            title: '推送消息',
            requiresAuth: true
        },
    },
    {
        path: '/rent',
        name: 'rent',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/other/Rent.vue'),
        meta: {
            title: '房屋出租',
            requiresAuth: false,
            isShowTabbar:false
        },
    },
    {
        path: '/recordPage',
        name: 'recordPage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/RecordPage.vue'),
        meta: {
            title: '宝记',
            requiresAuth: true,
            isShowTabbar:true
        },
    },
    {
        path: '/baoRecord',
        name: 'baoRecord',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/baorecord/BaoRecord.vue'),
        meta: {
            title: '宝记',
            requiresAuth: true,
            isShowTabbar:true
        }
    },
    {
        path: '/baoCommRecord',
        name: 'baoCommRecord',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/baorecord/BaoCommRecord.vue'),
        meta: {
            title: '宝记',
            requiresAuth: true,
            isShowTabbar:true
        },
    },
    {
        path: '/stock',
        name: 'stock',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/mine/Stock.vue'),
        meta: {
            title: '基金',
            requiresAuth: true,
            isShowTabbar:true
        },
    }
]

const router = new VueRouter({
    routes
})

//let storeCookies = Cookies.get('store')
//Cookies.get('store')
if (Cookies.get('store')) {
    //localStorage.getItem('store')
    //debugger
    //let sessionStore = localStorage.getItem('store');

    //store.replaceState(Object.assign({}, store.state,JSON.parse(localStorage.getItem("store"))));
    store.replaceState(Object.assign({}, store.state,JSON.parse(Cookies.get('store'))));
    //store.commit(types.LOGIN, window.sessionStorage.getItem('token'));
}

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title
    //let isLogin = store.state.isLogin
    //console.log(isLogin)
    // console.log("测试输出")
    //console.log("isLogin:"+store.state.sys.isLogin)
    //console.log("token:"+store.state.sys.token);
    //console.log("user:"+store.state.sys.user);

    //debugger
    if (title) {
        document.title = title
    }

//   store.commit(types.SYS + types.LOGOUT);
//   store.commit(types.SYS + types.PUT_TOCKEN,'JIEJFIEWOXNK*EJ');
//
    let isLogin = store.state.sys.isLogin
    //debugger
    if (to.matched.some(r => r.meta.requiresAuth)) {

        //console.log("fullPath:" + to.fullPath)
        if (isLogin) {  // 通过vuex 如果当前有登录
            next();
        }
        else {
            next({
                path: '/pageLogin',
                query:{redirect: to.fullPath}
            })
        }
    }else{
        next();
    }
});


export default router
